import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";  
import "./login.css";
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { baseURL } from "../../constants/url";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function SignIn() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decoded.exp > currentTime) {
          navigate("/");
        } else {
          localStorage.removeItem("authToken");
          localStorage.removeItem("user");
        }
      } catch (err) {
        console.error("Invalid token:", err);
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
      }
    }

    document.querySelectorAll("input").forEach((input) => {
      if (input.value.trim() !== "") {
        input.classList.add("filled");
      }

      input.addEventListener("input", () => {
        if (input.value.trim() !== "") {
          input.classList.add("filled");
        } else {
          input.classList.remove("filled");
        }
      });
    });
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email.trim()) newErrors.email = "Username is required.";
    if (!formData.password.trim()) newErrors.password = "Password is required.";
    return newErrors;
    
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(`${baseURL}common/userlogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status?.toLowerCase() === "success" && result.data?.tokens?.access) {
        const token = result.data.tokens.access;
        localStorage.setItem("authToken", token);
        localStorage.setItem("user", JSON.stringify(result.data));
        const userId = result.data.user_id;
        localStorage.setItem("user_id", userId);

        setFormData({ email: "", password: "" });

        // SweetAlert2 Success Popup
        Swal.fire({
          title: "Success!",
          text: "Login successful!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/");
        });

      } else {
        setMessage("Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Login error:", error);
      setMessage("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="container-fluid login_bg">
        <div className="formContainer_box">
          <div className="formContainer">
            <div className="signInContainer">
              <h4 className="form_title">Login</h4>
              <form onSubmit={handleLogin}>
                <div className="inputSection">
                  <input
                    type="text"
                    name="email"
                    className="userName"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <label className="inputLabel">User Name</label>
                  {errors.email && <p className="formError">{errors.email}</p>}
                </div>
                <div className="inputSection">
                  <input
                      type={showPassword ? "text" : "password"}
                    name="password"
                    className="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <label className="inputLabel">Password</label>
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "46%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </span>
                  {errors.password && <p className="formError">{errors.password}</p>}
                </div>

                {message && <p className="formMessage">{message}</p>}
                <button className="saveForm" type="submit" disabled={loading}>
                  {loading ? "Logging in..." : "Login"}
                </button>
              </form>
              <div className="pr_20 pl_20 pb_15 mt_30 d_flex justify_sp_between">
                <Link to="/forgotpassword" className="font_13 common_color">Forgot Password?</Link>
                <Link to="/register" className="font_13 common_color">Sign Up</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
}
